(() => {
  function init() {
    const form = document.querySelector('.bw-product-search');
    if (!form || form.dataset.suggestionsReady) return;
    form.dataset.suggestionsReady = 'true';
    const input = form.querySelector('[name="q"]');
    const panel = form.querySelector('.bw-search-suggestions');
    const list = form.querySelector('.bw-search-suggestion-list');
    const status = form.querySelector('.bw-search-status');
    const all = form.querySelector('.bw-search-all');
    let timer, controller, revision = 0, active = -1;
    function options() { return Array.from(list.querySelectorAll('[role="option"]')); }
    function hide() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function dismiss() {
      clearTimeout(timer);
      if (controller) controller.abort();
      revision++;
      hide();
    }
    function show() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function searchURL(term) {
      const url = new URL(form.action, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url;
    }
    function setActive(index) {
      const items = options();
      if (!items.length) return;
      active = (index + items.length) % items.length;
      items.forEach((item, i) => item.setAttribute('aria-selected', String(i === active)));
      input.setAttribute('aria-activedescendant', items[active].id);
      items[active].scrollIntoView({block:'nearest'});
    }
    async function getResults(term, token) {
      controller = new AbortController();
      const url = searchURL(term);
      url.searchParams.set('view', 'json');
      try {
        const response = await fetch(url.toString(), {signal: controller.signal, headers: {'Accept':'application/json'}});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (token !== revision || input.value.trim() !== term) return;
        list.replaceChildren();
        const results = Array.isArray(data.results) ? data.results.slice(0, 10) : [];
        results.forEach((product, i) => {
          const target = new URL(product.url, window.location.origin);
          if (target.origin !== window.location.origin) return;
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = target.href;
          link.id = 'bw-product-option-' + i;
          link.className = 'bw-search-option';
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          link.tabIndex = -1;
          if (product.thumbnail && !product.thumbnail.includes('no-image')) {
            const imageURL = new URL(product.thumbnail, window.location.origin);
            if (imageURL.protocol === 'https:') {
              const image = document.createElement('img');
              image.src = imageURL.href;
              image.alt = '';
              image.width = 56;
              image.height = 56;
              link.append(image);
            }
          }
          const title = document.createElement('span');
          title.textContent = product.title;
          link.append(title);
          li.append(link);
          list.append(li);
        });
        const count = Number(data.results_count) || 0;
        status.textContent = results.length ? form.dataset.resultsLabel.replace('[count]', String(count)) : form.dataset.emptyLabel;
        all.href = searchURL(term).toString();
        all.textContent = form.dataset.allLabel + (count ? ' (' + count + ')' : '');
        all.hidden = false;
        form.setAttribute('aria-busy', 'false');
        show();
      } catch (error) {
        if (error.name === 'AbortError' || token !== revision) return;
        list.replaceChildren();
        status.textContent = '';
        all.href = searchURL(term).toString();
        all.textContent = form.dataset.allLabel;
        all.hidden = false;
        form.setAttribute('aria-busy', 'false');
        show();
      }
    }
    function schedule() {
      clearTimeout(timer);
      if (controller) controller.abort();
      const token = ++revision;
      const term = input.value.trim();
      active = -1;
      input.removeAttribute('aria-activedescendant');
      if (term.length < 2) { hide(); form.setAttribute('aria-busy', 'false'); return; }
      list.replaceChildren();
      all.hidden = true;
      status.textContent = form.dataset.loadingLabel;
      form.setAttribute('aria-busy', 'true');
      show();
      timer = setTimeout(() => getResults(term, token), 180);
    }
    input.addEventListener('input', schedule);
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) schedule(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { dismiss(); return; }
      if (panel.hidden) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(active < 0 ? (event.key === 'ArrowDown' ? 0 : options().length - 1) : active + (event.key === 'ArrowDown' ? 1 : -1));
      } else if (event.key === 'Enter' && active >= 0 && options()[active]) {
        event.preventDefault();
        options()[active].click();
      }
    });
    form.addEventListener('focusout', () => setTimeout(() => {
      if (!form.contains(document.activeElement)) dismiss();
    }, 0));
    document.addEventListener('click', event => { if (!form.contains(event.target)) dismiss(); });
    form.addEventListener('submit', dismiss);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
